import React from 'react';
import styled from 'styled-components/macro';
import { Spinner } from '../../components/ui';

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AppFallback = () => {
  return (
    <Container>
      <Spinner />
    </Container>
  );
};

export default AppFallback;
